import { Style, Fill, Stroke, Circle, Icon } from 'ol/style';

export class LocationMapStyles {
    static locationDefaultStyle = new Style({ image: new Circle({ stroke: new Stroke({ color: 'rgba(0, 0, 255, 1)', width: 3 }), radius: 20 }), stroke: new Stroke({ color: 'rgba(0, 0, 250, 0.7)', width: 16 }) });
    static locationStyleCache = {
        "Default": LocationMapStyles.locationDefaultStyle
    };
}




